import styled from 'styled-components';
export const FlightServe = styled.div`
  width: 60%;
`;
export const HotelsServe = styled.div`
  width: 40%;
  a {
    text-decoration: none;
  }
`;

export const HotelIco = styled.img`
  width: 16px;
`;
